<div class="box">
    <mat-icon style="color: white; user-select: none">dns</mat-icon>
</div>
<p class="name">{{ UserName }}</p>
